import React from "react";
import { Link } from 'react-router-dom';
import { CssBaseline, Stack } from "@mui/material";
import "../css/Morquee.css";
import MiddleContent from "./MiddleContent";
import EventTabs from "./eventComponent/EventTabs/EventTabs";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import EventTabsWithServiceButtons from "./EventTabsWithServiceButtons";
import { UseMyaccount } from "./Myaccountuse";

const Dashboard = () => {
  UseMyaccount();

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />
      <div style={{ padding: '16px 24px' }}><Link to="/dashboard/calendar">My Calendar</Link></div>
      {/* <EventTabs /> */}
      <EventTabsWithServiceButtons />
      <MiddleContent params={"dashboard"} />
     <Footer />
    </div>
  );
};

export default Dashboard;
